import { BasePage } from 'src/pages/base.page';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { GraficoViewModel } from './GraficoViewModel';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { GraficoAtivoModel } from 'projects/core/src/lib/core/model/GraficoAtivoModel';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { GatewayService } from 'projects/core/src/lib/core/GatewayService';

import { Style, StatusBar } from '@capacitor/status-bar';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { SanitizePipe } from 'src/app/pipes/sanitize.pipe';

@Component({
    selector: 'grafico-page',
    templateUrl: 'grafico.page.html',
    styleUrls: ['grafico.page.scss']
})
export class GraficoPage extends BasePage {
    constructor(
        public router: Router,
        private alertController: AlertController, 
        public loadingController: LoadingController,
        private activatedRoute: ActivatedRoute,
        private platform: Platform) {
            super(router)

            if (this.platform.is('ios')) {
                setTimeout(() => {
                    StatusBar.setStyle({
                        style: Style.Light
                    });
                }, 1000)
            }
    }

    graficoViewModel: GraficoViewModel
    alertComponent: AlertComponent
    loadingComponent: LoadingComponent
    graficoAtivo: GraficoAtivoModel = new GraficoAtivoModel()
    data: any
    url: String = new GatewayService().getBaseUrl() + '/psjs2/'
    safeURL: SafeResourceUrl

    ngOnInit() {
        this.iniciaVariaveis()
        this.buscaGraficoAtivo()
    }

    iniciaVariaveis() {
        this.data = this.decodeData(this.activatedRoute.snapshot.paramMap.get('data'));

        this.graficoViewModel = new GraficoViewModel()
        this.graficoViewModel.setContext(this)
        this.loadingComponent = new LoadingComponent(this.loadingController)
    }

    async buscaGraficoAtivo() {
        this.safeURL = this.url
        if (this.data.codigo_ativo) this.safeURL += "?ativo=" + this.data.codigo_ativo
        if (this.data.gr_entrada) this.safeURL += "&entrada=" + this.data.gr_entrada;
        if (this.data.gr_objetivo) this.safeURL += "&objetivo=" + this.data.gr_objetivo;
        if (this.data.gr_stop) this.safeURL += "&stop=" + this.data.gr_stop;
        if (this.data.gr_date) this.safeURL += "&date=" + this.data.gr_date;
        if (this.data.gr_timeframe) this.safeURL += "&tg=" + this.data.gr_timeframe;
        this.safeURL += "&token=" + (await AppSession.getToken()).access_token;
    }

    async showLoading() {
        return await this.loadingComponent.showLoading()
    }
  
    showAlert(title: string, message: string) {
        AlertComponent.showAlert(title, message)
    }

    setGraficoAtivo(graficoAtivo: GraficoAtivoModel) {
        this.graficoAtivo = graficoAtivo
    }
}